import { render, staticRenderFns } from "./LicenseApplys.vue?vue&type=template&id=3c124808&scoped=true&"
import script from "./LicenseApplys.vue?vue&type=script&lang=js&"
export * from "./LicenseApplys.vue?vue&type=script&lang=js&"
import style0 from "./LicenseApplys.vue?vue&type=style&index=0&id=3c124808&scoped=true&lang=css&"
import style1 from "./LicenseApplys.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c124808",
  null
  
)

export default component.exports